import ConfirmModal from './ConfirmModal';

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmModal/index.jsx